import { Box, InputAdornment, TextField } from "@mui/material"
import { FilterAltOutlined, SearchOutlined } from "@mui-symbols-material/w300"
import { useNavigate, useSearch } from "@tanstack/react-router"
import type { ChangeEvent, FC } from "react"

import { Button } from "@/components/common/Button"
import { getRefinedSearchParams } from "@/utils/getRefinedSearchParams"

interface ProductsHeaderActionsProps {
  setFilterDrawerOpen: (open: boolean) => void
}

const ProductsHeaderActions: FC<ProductsHeaderActionsProps> = ({ setFilterDrawerOpen }) => {
  const navigate = useNavigate()
  const currentSearch = useSearch({ from: "/app/products/" })

  const handleSearchInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const queryValue = e.target.value

    const updatedSearchParams = getRefinedSearchParams({
      ...currentSearch,
      query: queryValue,
    })

    void navigate(updatedSearchParams)
  }
  return (
    <Box className='flex space-x-4'>
      <TextField
        data-testid='products-search-input'
        variant='outlined'
        placeholder='Search by Product Name or Product ID...'
        defaultValue={currentSearch?.query}
        className='w-full max-w-lg'
        onChange={handleSearchInputChange}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position='start'>
                <SearchOutlined className='text-gray-600' />
              </InputAdornment>
            ),
          },
        }}
      />
      <Box className='flex w-full justify-between'>
        <Button
          appearance='outlined'
          value='Filter'
          startIcon={<FilterAltOutlined />}
          onClick={() => setFilterDrawerOpen(true)}
          rootElementName='button'
        />
      </Box>
    </Box>
  )
}

export default ProductsHeaderActions
